import React from 'react';
import MobiLogoIcon from 'assets/icons/MobiLogoIcon';
import AviogoLogo from 'tenants/aviogo/Logo';
import MobianLogo from 'tenants/mobian/Logo';
import DenHaagLogo from 'tenants/den-haag/Logo';
import DominosLogo from 'tenants/dominos/Logo';

const TenantLogo = (props) => {
    switch (process.env.REACT_APP_TENANT) {
        case 'aviogo':
            return <AviogoLogo { ...props } />;
        case 'den-haag':
            return <DenHaagLogo { ...props } />;
        case 'dominos':
            return <DominosLogo { ...props } />;
        case 'mobian':
            return <MobianLogo { ...props } />;
        default:
            return <MobiLogoIcon { ...props } />;
    }
};

export default TenantLogo;


// WEBPACK FOOTER //
// ./src/tenants/Logo.js